import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AccentThemeProvider } from './contexts/AccentTheme'
import Header from './components/Header'
import Footer from './components/Footer'
import Landing from './pages/Landing'

export default function App() {
  return (
    <AccentThemeProvider>
    <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
    </AccentThemeProvider>
  )
}
